import Footer from "../components/Footer";

const services = [
  {
    title: "Invoicing & Billing",
    description:
      "Easily generate and manage invoices for dine-in, takeaway, or delivery orders. Compatible with both normal and thermal printers for seamless operations.",
  },
  {
    title: "Inventory & Stock Management",
    description:
      "Track ingredients, get real-time stock updates, and reduce waste with our smart inventory system designed specifically for food businesses.",
  },
  {
    title: "QR-Based Digital Menu",
    description:
      "Generate beautiful, mobile-friendly QR menus that your customers can scan and order from, reducing contact and improving service speed.",
  },
  {
    title: "Integrated Payments",
    description:
      "Accept payments directly on invoices — in-store or via secure payment links. We partner with Cashfree to ensure fast, compliant transactions. Platform fee: 2%. Payment commission: 10%.",
  },
  {
    title: "Sales & Analytics",
    description:
      "Get actionable insights from detailed reports on sales, revenue trends, customer behavior, and inventory usage to grow your business strategically.",
  },
  {
    title: "Multi-Outlet Support",
    description:
      "Manage multiple branches or kitchens under one account, with centralized access to billing, inventory, and analytics.",
  },
  
];

const Services = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-center mb-8">Our Services</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {services.map((service, index) => (
          <div
            key={index}
            className="bg-white p-6 shadow rounded-lg border border-gray-100 hover:shadow-md transition"
          >
            <h2 className="text-xl font-semibold mb-2">{service.title}</h2>
            <p className="text-gray-700">{service.description}</p>
          </div>
        ))}
      </div>
      <p className="text-sm text-gray-500 text-center mt-12">
        All services are part of the Bill-lex platform by{" "}
        <strong>Lexora Technologies OPC Private Limited</strong>.
      </p>
      <Footer />
    </div>
  );
};

export default Services;
